import styled from 'styled-components';
import { BaseEditField } from 'legacyComponents/styled/lib';

export const Name = styled.h2`
  font-size: 1.5em;
  margin: 6px 0px 0px 0px;
  text-align: center;
`;

export const NameInput = styled(BaseEditField)`
  position: relative;
  width: 320px;
  font-size: 1.5em;
  margin: 4px auto 4px auto;
  display: block;
  > input {
    font-weight: 600;
    text-align: center;
    width: 100%;
  }
  ::placeholder {
    font-weight: 600;
  }
`;
